<template>
<div>
  <v-container  grid-list-lg class="ma-0 pa-0">
  <v-layout row class="mt-4 mb-4">
    
   <v-card
          row
          class="mt-2"
        >
          <v-card-title
            primary-title
            class="grey lighten-4"
          >
            <h3 class="title mb-0">Statistik</h3>
            <!-- <v-btn @click="CheckBetrieb()" icon class="my-0" flat> 
              <v-icon>refresh</v-icon>
            </v-btn> -->
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
  
      <v-sparkline
        :labels="labels"
        :value="value"
        color="accent"
        line-width="2"
        padding="16"
      ></v-sparkline>
   

  
      <div class="title font-weight-light mb-2">Suchen</div>
      <div class="subheading font-weight-light grey--text">Last Campaign Performance</div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        schedule
      </v-icon>
      <span class="caption grey--text font-weight-light">last registration 26 minutes ago</span>
    </v-card-text>
  </v-card>
  </v-layout>
  </v-container>
</div>

</template>

<script>
  export default {
    data: () => ({
      labels: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm'
      ],
      value: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240
      ]
    })
  }
</script>
<style scoped>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>